import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Icon from '@material-ui/core/Icon';
import AddCircle from '@material-ui/icons/AddCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import { Typography, Dialog } from '@material-ui/core';
import { GetApiKeys, DropApiKey, AddApiKey } from 'App/Administracion/Actions';
import { AdministracionContext } from "App/Administracion/store";
import { LayoutContext } from "App/Layout/store";
import moment from 'moment';
import axios from 'axios';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    textAlignRight: {
        textAlign: "right"
    },
    iconHover: {
        '&:hover': {
            color: "rgb(61,30,144)",
            cursor: "pointer"
        }
    }
});

function ApiKeys(props) {
    const { classes, theme } = props;
    const administracionContext = useContext(AdministracionContext);
    const layoutContext = useContext(LayoutContext);

    useEffect(() => {
        GetApiKeys(administracionContext.dispatch)
    }, []);

    var dias = 0;

    return (
        <div>

            <Grid container spacing={24}>
                <Grid item sm={12}>
                    <Typography variant="h5">Claves Solicitadas</Typography>
                </Grid>
                <Grid item sm={12} className={classes.textAlignRight}>
                    <Tooltip title="Agregar clave">
                        <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
                            evt.preventDefault();
                            layoutContext.dispatch({
                                type: "setAlert", Alert: {
                                    Accion: () => {dias>0?AddApiKey(layoutContext.dispatch,administracionContext.dispatch,dias):alert("Debe ser al menos un día")},
                                    titulo: "Agregar Api Key",
                                    contenido: <div>
                                        <p>Por cuántos días desea extender esta Api Key?</p>
                                        <input onChange={e=>dias=parseInt(e.target.value)} type="number"/>
                                    </div>
                                }
                            })
                        }}>
                            <AddCircle />
                        </Icon>
                    </Tooltip>
                </Grid>
                <Grid item sm={12}>
                    <Paper className={classes.root}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Clave</TableCell>
                                    <TableCell>Fecha de Creacion</TableCell>
                                    <TableCell>Eliminar</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(administracionContext.state.claves.listado).map((clave, ix) => {
                                    return (
                                        <TableRow key={ix}>
                                            <TableCell component="th" scope="row">
                                                {clave.ID}
                                            </TableCell>
                                            <TableCell>{moment(clave.FechaCreacion).format("L")}</TableCell>
                                            <TableCell>
                                                <Tooltip title="Eliminar clave">
                                                    <Icon color="error" className={classes.iconHover} onClick={(evt) => {
                                                        evt.preventDefault();
                                                        layoutContext.dispatch({
                                                            type: "setAlert", Alert: {
                                                                Accion: () => DropApiKey(administracionContext.dispatch,[clave.ID]),
                                                                titulo: "¿Está seguro?",
                                                                contenido: "¿Está seguro que desea eliminar esta Api Key? Esta acción es irreversible."
                                                            }
                                                        })
                                                    }}>
                                                        <RemoveCircle />
                                                    </Icon>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

ApiKeys.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ApiKeys);